export default __webpack_public_path__ + "e71bc3ae147e2be07e882829f5a82e14.png";